import { AccountItemBlock } from "./AccountItem";
import { AutoEmail } from "./AutoEmail";
import NoteExpiryTime from "./NoteExpiryTime";
import { EmailExportTypeForm } from "../email/EmailExportTypeForm";

export default function EmailExportingSettings({
  control,
  setValue,
  data,
  refetch,
}) {
  return (
    <div
      id="accountAutoExport"
      className="flex-1 flex flex-col gap-md"
    >
      <div className="flex flex-col space-y-4 divide-y divide-secondary">
        <AccountItemBlock
          title="Auto Export Email:"
          desc="SOAPs will
            automatically export to this address once you've
            completed them."
        >
          <AutoEmail data={data} refetch={refetch} />
        </AccountItemBlock>
        <AccountItemBlock
          title="Auto Export Email Type:"
          desc="Set whether
              automatically exported notes are sent as a link or
              embedded directly in the email."
        >
          <EmailExportTypeForm
            control={control}
            setValue={setValue}
            data={data}
            isForAccountSetting={true}
            refetch={refetch}
          />
        </AccountItemBlock>
        <AccountItemBlock
          title="Note Link Expiry Time:"
          desc="The length of
              time your emailed SOAPs (and optional attachments) will
              be available to access. Note that edits to notes over
              this time will be viewable by your email export
              recipient."
        >
          <NoteExpiryTime
            key={`note-expiry-${data?.user?.emailExpiryDays ?? 1}`}
            data={data}
            refetch={refetch}
          />
        </AccountItemBlock>
      </div>
    </div>
  );
}
